require('./bootstrap')
let $root = require('./root').default
$root.$mount('#app')



// WEBPACK FOOTER //
// ./resources/assets/js/app.js